import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button, Icon } from '@src/components/ui';
import { useImpersonation } from '../../contexts/ImpersonationContext';
import { useNavigate } from 'react-router-dom';
import styles from './AdminImpersonationBanner.module.scss';
// Forwards a ref to the root element so Layout can measure its actual rendered height (the
// banner is position: fixed, so it doesn't push page content down on its own - Layout adds
// matching top padding to its content area instead).
const AdminImpersonationBanner = forwardRef((_props, ref) => {
    const { isImpersonating, impersonatedClinic, stopImpersonation } = useImpersonation();
    const navigate = useNavigate();
    if (!isImpersonating || !impersonatedClinic) {
        return null;
    }
    const handleCancelOrder = () => {
        stopImpersonation();
        navigate('/web-admin');
    };
    return (_jsx("div", { className: styles.banner, ref: ref, children: _jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.icon, children: _jsx(Icon, { faIconName: "fa-solid fa-user", faSize: "1x" }) }), _jsxs("div", { className: styles.infoText, onClick: handleCancelOrder, children: [_jsx("span", { className: styles.label, children: "Ordering for:" }), _jsx("span", { className: styles.clinicName, children: impersonatedClinic.name }), _jsx("span", { className: styles.cancelIcon, children: _jsx(Icon, { faIconName: "fa-solid fa-times-circle", faSize: "1x" }) })] })] }), _jsx(Button, { variant: "secondary", size: "small", onClick: handleCancelOrder, className: styles.cancelButton, children: "Cancel Order" })] }) }));
});
AdminImpersonationBanner.displayName = 'AdminImpersonationBanner';
export default AdminImpersonationBanner;
